<template>
<div class="record">
    <div class="yesRecord">
        <div class="recordTop">
            <div class="clearfix">
                <i>
                    <router-link to='/makeMoney'>
                        <img src="../../../static/images/shootShop/back.png" alt="">
                    </router-link>
                </i>
                <h3>拍店记录</h3>
            </div>
            <div class="recordNav">
                <ul class="clearfix">
                    <li class="li1" :class="{'on':tab===0}" @click="reviewFun()">审核中<span></span></li>
                    <li class="li2" :class="{'on':tab===1}" @click="yesFun()">已通过<span></span></li>
                    <li class="li3" :class="{'on':tab===2}" @click="noFun()">未通过<span></span></li>
                </ul>
            </div>
        </div>

        <!-- 审核中 -->
        <div class="recordWrap">

          <!--  <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange"
                   ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false"> -->

            <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange"
                   ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false">


                <div class="recordList" v-for="item in msg">
                    <ul class="clearfix">
                        <li class="fl li1">拍店时间：<span>{{item.createTime}}</span></li>
                        <li class="fr" v-if="item.type == 1">审核中</li>
                        <li class="fr" v-else-if="item.type == 2" style="color: #4cbe54">已通过</li>
                        <li class="fr" v-else="item.type == 3" style="color: #e62303">驳回原因：{{item.refusal}}</li>
                    </ul>

                    <dl class="clearfix">
                        <dt class="fl">
                            <img :src="item.img">
                        </dt>
                        <dd class="fl">
                            <h5>店主电话：{{item.phone}}</h5>
                            <p v-if="item.type == 1">奖励佣金：{{item.bonus}}</p>
                            <p v-if="item.type == 2" style="color: #ff7700;">奖励佣金：+{{item.bonus}}元</p>
                            <p v-if="item.type == 3">奖励佣金：+{{item.bonus}}元</p>
                        </dd>
                    </dl>

                </div>

                <div class="noData" v-if="more">没有更多数据了...</p></div>

            </mt-loadmore>
        </div>

        <!-- 暂无订单 -->
        <div class="noRecord" v-if="noRecord==0">
            <dl>
                <dt>
                    <img src="../../../static/images/mine/noOrders.png">
                </dt>
                <p>暂无数据</p>
            </dl>
        </div>
    </div>
</div>
</template>

<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'record',
    data () {
        return {
            tab: 0,
            msg: [], // 列表详情
            noRecord: [],// 无数据
            pageSize: 10, // 每次请求的数量
            brandIndex: 1, // 页码 
            allLoaded: false,
            more: false,
        }
    },
    computed:{

    },
    methods:{
        init(data){
            var that = this;
            this.$http(this.changeData() + "/photo/auth/getPhotoList",{
                method: 'post',
                params: data
            }).then(res => {
                console.log(res)
                try{
                    this.msg = res.data.data;
                    if(this.msg.length == 0){
                        this.noRecord = 0;
                    }else{
                        this.noRecord = 1;
                    }
                }catch(e){
                    console.log(e)
                }
            }).catch(err => {
              console.log(err)
            });
        },

        //上拉加载
        loadBottom() {
            let _this = this;
            this.brandIndex++;
            if(this.tab == 0){ 
                var data = {
                    cityId: sessionStorage.cityId, //市id
                    pageSize: this.pageSize,  //每页数据量
                    pageNum: this.brandIndex , // 页码从1开始
                    type: "1"   //1 待审核 2 审核通过 3 审核拒绝 
                }
            }else if(this.tab == 1){
                var data = {
                    cityId: sessionStorage.cityId, //市id
                    pageSize: this.pageSize,  //每页数据量
                    pageNum: this.brandIndex, // 页码从1开始
                    type: "2"   //1 待审核 2 审核通过 3 审核拒绝 
                }
            }else if(this.tab == 2){
                var data = {
                    cityId: sessionStorage.cityId, //市id
                    pageSize: this.pageSize,  //每页数据量
                    pageNum: this.brandIndex , // 页码从1开始
                    type: "3"   //1 待审核 2 审核通过 3 审核拒绝
                }
            }

            this.$http(this.changeData() + "/photo/auth/getPhotoList",{
                method: 'post',
                params: data
            }).then(res => {
                console.log(res.data.data)
                try{
                    _this.msg = _this.msg.concat(res.data.data);
                    if(res.data.data <= 0){
                        _this.allLoaded = true;
                    }
                    _this.$refs.loadmore.onBottomLoaded();
                }catch(e){
                    console.log(e)
                }
            }).catch(err => {
                console.log(err)
            });
        },

        //下拉刷新
        // loadTop(){ 

        //     var _this = this;
        //     let url = this.changeData() + '/photo/auth/getPhotoList'
        //     if(this.tab == 0){ 
        //         var data = {
        //             cityId: sessionStorage.cityId, //市id
        //             pageSize: this.pageSize,  //每页数据量
        //             pageNum: "1", // 页码从1开始
        //             type: "1"   //1 待审核 2 审核通过 3 审核拒绝 
        //         }
        //     }else if(this.tab == 1){
        //         var data = {
        //             cityId: sessionStorage.cityId, //市id
        //             pageSize: this.pageSize,  //每页数据量
        //             pageNum: "1", // 页码从1开始
        //             type: "2"   //1 待审核 2 审核通过 3 审核拒绝 
        //         }
        //     }else if(this.tab == 2){
        //         var data = {
        //             cityId: sessionStorage.cityId, //市id
        //             pageSize: this.pageSize,  //每页数据量
        //             pageNum: "1", // 页码从1开始
        //             type: "3"   //1 待审核 2 审核通过 3 审核拒绝
        //         }
        //     }

        //     setTimeout(function() {
        //         axios(url,{
        //             method: 'post',
        //             params: data
        //         }).then(data => {
        //             this.msg = data.data.data;
        //             _this.$refs.loadmore.onTopLoaded();
        //         }).catch(err => {
        //             console.log(err)
        //         });
        //     },1000);
        // },

        handleBottomChange(){
            var that = this;
            if(this.allLoaded == true){
                this.more = true;
                setTimeout(function () {
                    that.more = false;
                },1000)
            }
        },

        reviewFun(){

            this.tab = 0;
            this.brandIndex = 1; // 页码 
            this.allLoaded = false;
            this.more = false;

            var data = {
                cityId: sessionStorage.cityId, //市id
                pageSize: this.pageSize,  //每页数据量
                pageNum: "1", // 页码从1开始
                type: "1"   //1 待审核 2 审核通过 3 审核拒绝
            }

            this.init(data);
        },
        
        yesFun(){
            this.tab=1;
            this.brandIndex = 1; // 页码 
            this.allLoaded = false;
            this.more = false;
            var data = {
                cityId: sessionStorage.cityId, //市id
                pageSize: this.pageSize,  //每页数据量
                pageNum: "1", // 页码从1开始
                type: "2"   //1 待审核 2 审核通过 3 审核拒绝
            }
            this.init(data);
        },

        noFun(){
            this.tab=2;
            this.brandIndex = 1; // 页码 
            this.allLoaded = false;
            this.more = false;
            var data = {
                cityId: sessionStorage.cityId, //市id
                pageSize: this.pageSize,  //每页数据量
                pageNum: "1", // 页码从1开始
                type: "3"   //1 待审核 2 审核通过 3 审核拒绝
            }
            this.init(data);
        },

    },
    mounted() {
        var that = this;
        this.reviewFun();
    }
}
</script>
<style scoped lang="scss"  type="text/scss">

body{
    width: 7.5rem;
    background: #f7f8fa;
}

/*浮动*/
.fr{
    float: right;
}
.fl{
    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

.record{
    width: 7.5rem;
    background: #f7f8fa;
}
.recordTop{
    position: fixed;
    top: 0;
    left: auto;
    height: 2rem;
    text-align: center;
    background: #fff;
    border-bottom: 0.02rem solid #eee;
    z-index: 999;
    h3{
        width: 75%;
        line-height: 1rem;
        font-size: 0.36rem;
        color: #333;
        float: left;
        text-align: center;
    }
    i{
        display: inline-block;
        width: 13%;
        height: 1rem;
        line-height: 1rem;
        float: left;
        a{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            img{
                width: 0.2rem;
                height: 0.37rem;
            }
        }
    }
}
.recordNav{
    width: 7.5rem;
    height: 1rem;
    li{
        height: 1rem;
        float: left;
        color: #555;
        text-align: center;
        position: relative;
        font-size: .28rem;
        span{
            display: none;
            width: .62rem;
            height: .04rem;
            background: #49ACFF;
            position: absolute;
            left: 50%;
            margin-left:-.31rem;
            bottom: 0;
        }
        &.on{
            color: #64abff;
            span{
                display: block;
            }
        }
    }
    .li1,.li2,.li3{
        width: 2.5rem;
        line-height: 1rem;
    }
}

.recordWrap{
    width: 7.1rem;
    margin: 2rem auto 0;

}
.recordList{
    width: 6.7rem;
    padding: 0 .2rem;
    background: #fff;
    margin-top: .2rem;
    ul{
        padding: .3rem 0;
        border-bottom: .02rem solid #e7e7e7;
        li{
            font-size: .24rem;
            color: #2f7af7;
        }
        .li1{
            color: #363636;
        }
    }
    dl{
        padding: .2rem 0;
        dt{
            width: 2.26rem;
            height: 1.52rem;
            margin-right: .3rem;
            img{
                width: 2.26rem;
                height: 1.52rem;
            }
        }
        dd{
            h5{
                color: #363636;
                font-size: .26rem;
                line-height: .42rem;
                margin: .28rem 0 .16rem;
            }
            p{
                color: #9f9fa8;
                font-size: .26rem;
                line-height: .4rem;
            } 
        }
    }
}

/*无数据*/
.noRecord{
    width: 7.5rem;
    dl{
        width: 7.5rem;
        text-align: center;
        dt{
            margin-top: 1.4rem;
            img{
                width: 3rem;
                height: 3rem;
            }
        }
        p{
            font-size: .28rem;
            color: #898989;
            margin-top: .38rem;
            margin-bottom: .5rem;
        }
        dd{
          -webkit-tap-highlight-color: rgba(0,0,0,0);
            span{
              -webkit-tap-highlight-color: rgba(0,0,0,0);
                display: inline-block;
                width: 3rem;
                height: .89rem;
                background: #47abff;
                line-height: .89rem;
                color: #fff;
                font-size: .34rem;
                border-radius: 5px;
            }
        }
    }
}
.noData{
    text-align: center;
    line-height: 1rem;
    font-size: .3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/shootShop/record.vue